import React, { useMemo } from "react";
import { Platform, StyleProp, StyleSheet, TouchableOpacity, ViewStyle } from "react-native";

import Icon from "./Icon";
import { useTheme } from "../hooks/use-theme";

export type InfoButtonSize = "small" | "medium" | "large";

type InfoButtonProps = {
    onPress: () => void;
    style?: StyleProp<ViewStyle>;
    size?: InfoButtonSize;
};

const SIZE_MAP: Record<InfoButtonSize, number> = {
    small: 14,
    medium: 17,
    large: 24,
};

const InfoButton: React.FC<InfoButtonProps> = ({ onPress, style, size = "medium" }) => {
    const iconSize = SIZE_MAP[size];
    const { colors } = useTheme();
    const styles = useStyles();
    const slopSize = 50;
    return (
        <TouchableOpacity
            onPress={onPress}
            style={[styles.container, style]}
            hitSlop={{ top: slopSize, right: slopSize, bottom: slopSize, left: slopSize }}
        >
            <Icon
                style={[
                    styles.icon,
                    {
                        borderRadius: iconSize / 2,
                        marginLeft: iconSize / 4,
                    },
                ]}
                color={colors.secondary}
                name="info"
                size={iconSize}
                iconPadding={3}
            />
        </TouchableOpacity>
    );
};

const useStyles = () => {
    const { colors } = useTheme();
    return useMemo(
        () =>
            StyleSheet.create({
                icon: {
                    marginBottom: Platform.OS === "android" ? -3 : 0,
                    backgroundColor: colors.background,
                    borderColor: colors.secondary,
                    borderWidth: 1,
                },
                container: {
                    zIndex: 10,
                },
            }),
        [colors.background, colors.secondary],
    );
};

export default InfoButton;
